var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99701 11.9405C1.99701 17.4167 6.52082 21.9405 11.997 21.9405C17.4732 21.9405 21.997 17.4167 21.997 11.9405C21.997 6.46429 17.4732 2 11.997 2C6.52082 2 1.99701 6.46429 1.99701 11.9405ZM15.6875 16.5833C13.3661 15.1548 10.3899 14.7976 6.93749 15.5714C6.10415 15.6905 5.9851 14.5 6.69939 14.381C10.5089 13.4881 13.7232 13.9048 16.3422 15.5119C16.997 15.9286 16.3422 16.9405 15.6875 16.5833ZM16.6994 13.9048C14.0208 12.2381 9.91368 11.7619 6.75891 12.7143C5.74701 13.0119 5.38987 11.4643 6.34225 11.2262C9.9732 10.1548 14.4375 10.6905 17.5327 12.5952C18.3661 13.131 17.5327 14.4405 16.6994 13.9048ZM6.28272 9.67857C5.27082 10.0357 4.61606 8.30952 5.74701 7.89286C9.25891 6.82143 15.2113 7 18.9018 9.20238C19.9137 9.73809 18.9613 11.4048 17.8899 10.8095C14.6756 8.90476 9.31844 8.72619 6.28272 9.67857Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyIcon);
export default __webpack_public_path__ + "static/media/spotify-icon.08b6addcbea51922211cc835951535c9.svg";
export { ForwardRef as ReactComponent };